import { _ as __assign, c as __read } from './chunks/tslib.es6-ebb56484.js';
import * as React from 'react';
import React__default, { useMemo, useState, useEffect, useCallback } from 'react';
import { Typography, Button, Space, Icon, Rate, Divider } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';
import { makeCreateReviewLink } from '@sravni/ugc/lib/organizations/linkMakers';
import { c as cn } from './chunks/index-9d6795ea.js';

/**
 * @description Bug icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Bug } from '@sravni/design-system-icons'
 *
 * <Bug />
 * ```
 */
var Bug = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Bug", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.238 5.635-.873 1.746-1.164.8M3.889 10h2.715M13.396 10h2.715M4.762 2.143h-.873c-.965 0-1.746.781-1.746 1.746v.873M15.238 17.857h.873c.965 0 1.746-.781 1.746-1.746v-.873M2.143 15.238v.873c0 .965.78 1.746 1.746 1.746h.873M17.857 4.762V3.89c0-.965-.781-1.746-1.746-1.746h-.873M4.762 5.635l.873 1.746 1.163.8M10.387 14.366h-.776a2.619 2.619 0 0 1-2.619-2.62V9.127c0-.964.782-1.746 1.746-1.746h2.522c.965 0 1.746.782 1.746 1.746v2.62a2.619 2.619 0 0 1-2.619 2.619ZM4.762 14.365l.873-1.746 1.163-.8M15.238 14.365l-.873-1.746-1.164-.8M11.746 7.381H8.254V5.635c0-.482.391-.873.873-.873h1.746c.482 0 .873.391.873.873v1.746Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

/**
 * @description Review icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Review } from '@sravni/design-system-icons'
 *
 * <Review />
 * ```
 */
var Review = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Review", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.5 17.927V15h4.167c.46 0 .833-.373.833-.833V3.333a.834.834 0 0 0-.833-.833H3.333a.834.834 0 0 0-.833.833v10.834c0 .46.373.833.833.833h5l4.167 2.927v0ZM12.5 10.833H5.833M5.833 6.667h8.334", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

/**
 * @description Shield icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Shield } from '@sravni/design-system-icons'
 *
 * <Shield />
 * ```
 */
var Shield = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Shield", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.667 9.318c0 3.784-2.845 7.323-6.667 8.182-3.823-.86-6.667-4.398-6.667-8.182V6.346c0-.677.41-1.287 1.036-1.543l4.167-1.705a3.864 3.864 0 0 1 2.928 0l4.167 1.705a1.667 1.667 0 0 1 1.036 1.543v2.972Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m12.708 8.438-3.125 3.124-1.875-1.874", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

var HOW_WE_WORK_TITLE = 'Почему нам доверяют';
var ACTION_BUTTON_TEXT = 'Написать отзыв';
var LINK_HOW_WE_WORK = '/document/review-rules/';
var TEXT_BUTTON_HOW_WE_WORK = 'Подробнее';
var DESCRIPTION_RATED = 'Спасибо! Дополните оценку отзывом, чтобы ее\u00A0опубликовать';
var DESCRIPTION_UNRATED = 'Оцените свой опыт или решите проблему у\u00A0нас на\u00A0сайте';
var HEADER_FORM = 'Оставьте отзыв';

var modules_77a29656 = {"wrapper":"_gihloa","wrapper--isAddReviewPage":"_8sl0x","link":"_1l4vxb4","btn":"_1bc8gq7"};
import "./assets/ReviewsActionBlock.css";

var ActionButton = function (_a) {
    var link = _a.link, handleClickActionButton = _a.handleClickActionButton;
    return (React__default.createElement(Typography.Link, { className: modules_77a29656.link, href: link, onClick: handleClickActionButton },
        React__default.createElement(Button, { className: modules_77a29656.btn, color: "dark", size: 52, variant: "primary", block: true }, ACTION_BUTTON_TEXT)));
};

var IS_ADD_REVIED_PAGE_DATA = [
    {
        icon: React__default.createElement(Shield, null),
        text: 'Внимательно анализируем каждую ситуацию'
    },
    {
        icon: React__default.createElement(Review, null),
        text: 'Ответы от представителя организаций и экспертов Сравни'
    },
];
var IS_NOT_ADD_REVIED_PAGE_DATA = [
    {
        icon: React__default.createElement(Shield, null),
        text: 'Модерация отзывов'
    },
    {
        icon: React__default.createElement(Bug, null),
        text: 'Удаление спама'
    },
    {
        icon: React__default.createElement(Review, null),
        text: 'Ответы от представителей организаций и экспертов Сравни'
    },
];

var modules_4bba97ad = {"icon":"_1ou2lmu"};
/*SRAVNI__src/components/ReviewsActionBlock/src/components/HowWeWorkIcon/how-we-work-icon.module.scss__SRAVNI*/;

var HowWeWorkIcon$1 = function (_a) {
    var text = _a.text, icon = _a.icon, key = _a.key;
    return (React__default.createElement(Space, { direction: "horizontal", align: "center", size: 12, key: "info-item-".concat(key) },
        React__default.createElement(Icon, { size: 16, shape: "round", background: "dark", color: "dark", className: modules_4bba97ad.icon }, icon),
        React__default.createElement("div", null, text)));
};

var HowWeWork = function (_a) {
    var isAddReviewPage = _a.isAddReviewPage;
    var listData = isAddReviewPage ? IS_ADD_REVIED_PAGE_DATA : IS_NOT_ADD_REVIED_PAGE_DATA;
    var list = useMemo(function () {
        return listData.map(function (_a, i) {
            var text = _a.text, icon = _a.icon;
            return React__default.createElement(HowWeWorkIcon$1, { text: text, icon: icon, key: i });
        });
    }, [listData]);
    var Title = (isAddReviewPage ? Typography.Heading : Typography.Text);
    var titleProps = isAddReviewPage
        ? { level: 4, className: 'h-mb-12' }
        : { strong: true, size: 14 };
    return (React__default.createElement(Space, { className: cn(isAddReviewPage && modules_77a29656.wrapper), direction: "vertical", size: 12 },
        React__default.createElement(Title, __assign({}, titleProps), HOW_WE_WORK_TITLE),
        list,
        isAddReviewPage && (React__default.createElement(Typography.Link, { href: LINK_HOW_WE_WORK, target: "_blank", strong: true, className: "h-mt-12" }, TEXT_BUTTON_HOW_WE_WORK))));
};

var ReviewsActionBlock$1 = function (_a) {
    var organizationType = _a.organizationType, organizationId = _a.organizationId, productTag = _a.productTag, productId = _a.productId, _b = _a.isAddReviewPage, isAddReviewPage = _b === void 0 ? false : _b, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c, _d = _a.isOnlyMobileButton, isOnlyMobileButton = _d === void 0 ? false : _d, _e = _a.hasHowWeWork, hasHowWeWork = _e === void 0 ? false : _e, handleClickActionButton = _a.handleClickActionButton;
    var _f = __read(useBoolean(false), 2), isSelectRate = _f[0], setIsSelectRate = _f[1];
    var _g = __read(useState(0), 2), rate = _g[0], setRate = _g[1];
    var _h = __read(useState(), 2), link = _h[0], setLink = _h[1];
    useEffect(function () {
        var link = makeCreateReviewLink({
            organizationType: organizationType,
            organizationId: organizationId,
            productTag: productTag,
            productId: productId,
            rate: rate
        });
        setLink(link);
    }, [organizationId, organizationType, productId, productTag, rate]);
    var handleChangeRate = useCallback(function (value) {
        setIsSelectRate.on();
        setRate(value);
    }, [setIsSelectRate]);
    var descriptionRate = isSelectRate ? DESCRIPTION_RATED : DESCRIPTION_UNRATED;
    var actionButtonProps = { link: link, handleClickActionButton: handleClickActionButton };
    if (isAddReviewPage)
        return React__default.createElement(HowWeWork, { isAddReviewPage: isAddReviewPage });
    if (isOnlyMobileButton)
        return React__default.createElement(ActionButton, __assign({}, actionButtonProps));
    return (React__default.createElement("div", { className: modules_77a29656.wrapper },
        React__default.createElement(Space, { direction: "vertical", align: isMobile ? 'center' : 'start', size: 16 }, isMobile ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ActionButton, __assign({}, actionButtonProps)),
            React__default.createElement(Typography.Text, { size: 14 }, DESCRIPTION_UNRATED))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography.Heading, { level: 3 }, HEADER_FORM),
            React__default.createElement(Typography.Text, { size: 14 }, descriptionRate),
            React__default.createElement(Rate, { size: 36, onChange: handleChangeRate }),
            React__default.createElement(ActionButton, __assign({}, actionButtonProps)),
            hasHowWeWork && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Divider, { className: "h-mt-8 h-mb-8" }),
                React__default.createElement(HowWeWork, null))))))));
};

export { ReviewsActionBlock$1 as ReviewsActionBlock };
